
const mixin = {
  state() {
    return {
      version:     null,
      maintenance: null,
    }
  },

  getters: {
    versionString: state => {
      const strings = []
      if(state.version)     strings.push(state.version)
      if(state.maintenance) strings.push('MAINTENANCE')
      return strings.join('/')
    }
  },

  mutations: {
    version    (state, value) {state.version     = value},
    maintenance(state, value) {state.maintenance = value},
  },
}

export default mixin
